import React from "react";
import { useNavigate } from "react-router-dom";
import { ROUTE_CONSTANTS } from "../constants/routeConstants";
import { Avatar, icons, sameRecipient, shortLabel } from "../utils/recipients";

const MAX_BUBBLES = 8;

/**
 * "Send again" row on the Send screen: favorites first, then recent recipients, as tappable
 * avatars. Visible without touching the "To" field, so senders can see the feature exists.
 * Renders nothing for a sender who has never sent money.
 */
const PeopleStrip = ({ people, selected, onPick }) => {
  const navigate = useNavigate();
  if (!people.length) {
    return null;
  }
  return (
    <section className="np-people-strip" aria-label="Send again">
      <div className="np-people-strip-head">
        <span className="np-people-strip-title">Send again</span>
        <button
          type="button"
          className="np-people-strip-all"
          onClick={() => navigate(ROUTE_CONSTANTS.PEOPLE)}
        >
          See all
        </button>
      </div>
      <div className="np-people-strip-row">
        {people.slice(0, MAX_BUBBLES).map((p) => {
          const active = sameRecipient(p, selected);
          return (
            <button
              type="button"
              key={`${p.type}:${p.value}`}
              className={`np-person-bubble${active ? " is-active" : ""}`}
              onClick={() => onPick(p.value)}
              aria-pressed={active}
              title={p.value}
            >
              <span className="np-person-avatar">
                <Avatar entry={p} large />
                {p.saved && <span className="np-person-star">{icons.star(true, 12)}</span>}
              </span>
              <span className="np-person-name">{shortLabel(p)}</span>
            </button>
          );
        })}
      </div>
    </section>
  );
};

export default PeopleStrip;
